const EventEmitter = require('events').EventEmitter
var moment = require('moment')
moment.locale('it')
import axios from './tAxios'
import storage from './tStorage'

import dbItem from './dbItem'
import evento from './evento'
import teras from '@/teras'


class contatto{
   constructor (args) {
      this.event = new EventEmitter()
      this.moment = moment

      this.profile = new dbItem({database:'esphm_abstract_2025',table:'contatto'})

      this.profile.event.on('loaded', async () =>{
         console.log("CONTATTO EVENT LOADED")
         storage.save('contatto',this.profile.row.id)      
         await this.init() 
      })

      this.autoreCerca = ''
      this._abstract = []
      return this
   }

   async getAbstract(){
      axios.query('fetchAll',`SELECT abstract.* 
      , GROUP_CONCAT(CONCAT(aut.cognome,' ',aut.nome) ORDER BY absaut.numero,aut.cognome,aut.nome SEPARATOR ', ') AS autori
      , GROUP_CONCAT(IF(absaut.primo=1,CONCAT(aut.cognome,' ',aut.nome),'') SEPARATOR '') AS presentingautore
      FROM abstract 
      LEFT JOIN abstract_autore AS absaut ON absaut.abstract=abstract.id 
      LEFT JOIN autore AS aut ON aut.id=absaut.autore
      WHERE abstract.contatto=→id AND abstract.evento=←evento 
      GROUP BY abstract.id 
      ORDER BY abstract.modificatoil DESC, abstract.iniziatoil  DESC, abstract.titolo`,{id: this.profile.row.id, evento: evento.profile.row.id},this,'_abstract')
      return new Promise((resolve, reject) => {resolve("Fatto")})
   }

   async saveAutore(){
      axios.query('fetchRow',`SELECT * FROM autore WHERE MD5(REPLACE(CONCAT(cognome,nome,affiliazione)," ",""))=MD5(REPLACE(CONCAT(→cognome,→nome,→affiliazione)," ",""))`,{cognome: this.profile.row.cognome, nome: this.profile.row.nome, affiliazione: this.profile.row.affiliazione}).then(async (response) => {
         console.log("CREO AUTORE FINITA QUERY")
         if(response.result.id > 0){
            console.log("CREO AUTORE TROVATO ID "+response.result.id)
         }else{
            console.log("CREO AUTORE IN BASE AL CONTATTO")
            let autore = new dbItem({table:'autore'})
            await autore.new()
            autore.row.cognome = this.profile.row.cognome
            autore.row.nome = this.profile.row.nome
            autore.row.affiliazione = this.profile.row.affiliazione
            autore.save()
            
         }
         return new Promise((resolve, reject) => {resolve("Fatto")})
      }).catch((error) => {return(error)})
      
   }
   
   async init(){
      await this.saveAutore()
      if(typeof evento.profile.row.id!='undefined')
         await this.getAbstract()
       
      this.profile.row.accesso = moment().format('YYYY-MM-DD HH:mm:00')   
      this.profile.row.versione = teras.version
      await this.profile.save()

      this.event.emit('init')

      return new Promise((resolve, reject) => {
         console.log("INIT finito per "+this.profile.row.nome)
         resolve("Fatto")
      })
   }

   checkEmail(emailCheck,idContatto){
      return new Promise((resolve, reject) => {
         axios.query('fetchOne',`SELECT email FROM contatto WHERE email=→email AND id!=→id AND id>0 LIMIT 1`,{email:emailCheck,id:idContatto}).then((response) => {
          var controllo = (response.result == emailCheck) ? false : true
          resolve(controllo)
        })
      })
   }


   



}
export default new contatto
